<template>
  <div class="features-tooltip">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'SchemeTooltip'
  }
</script>

<style scoped>
  .features-tooltip {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    font-family: 'RubicMedium', sans-serif;
    color: #453c34;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.34);
    transition: all 0.5s;
  }
  .features-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -10px;
    border: 10px solid;
  }
  .collect-tooltip {
    color: #453c34;
    background: linear-gradient(269.52deg, #c2f8ff 0.11%, #d9dfff 93.92%), #fff;
  }
  .collect-tooltip::after {
    border-color: #c2f8ff transparent transparent transparent;
  }
  .white-tooltip {
    color: #707070;
    background-color: #fff;
  }
  .white-tooltip::after {
    border-color: #fff transparent transparent transparent;
  }
  .yellow-tooltip {
    color: #7d5423;
    background-color: #ffe178;
  }
  .yellow-tooltip::after {
    border-color: #ffe178 transparent transparent transparent;
  }
  .green-tooltip {
    color: #fff;
    background-color: #2dc661;
  }
  .green-tooltip::after {
    border-color: #2dc661 transparent transparent transparent;
  }
  .blue-tooltip {
    color: #fff;
    background: #2190f6;
  }
  .blue-tooltip::after {
    border-color: #2190f6 transparent transparent transparent;
  }
  .mobile-tooltip {
    top: 18%;
    left: -0.8%;
  }
  .iot-tooltip {
    top: 33%;
    left: -3.4%;
  }
  .tracking-tooltip {
    top: 47%;
    left: -1%;
  }
  .any-format-tooltip {
    top: 62%;
    left: -4%;
  }
  .sensitize-tooltip {
    top: 16.5%;
    left: 28%;
  }
  .scheme-tooltip {
    top: 71%;
    left: 18.5%;
  }
  .data-lake-tooltip {
    top: 63%;
    left: 40.5%;
  }
  .enrich-tooltip {
    top: 4.5%;
    left: 40%;
  }
  .consumer-tooltip {
    top: 65%;
    left: 46.8%;
  }
  .api-tooltip {
    top: 10.5%;
    left: 60%;
  }
  .optimization-tooltip {
    top: 30.5%;
    left: 66.8%;
  }
  .marketing-tooltip {
    top: 37%;
    left: 60%;
  }
  .reporting-tooltip {
    top: 42%;
    left: 63.8%;
  }
  .campaign-tooltip {
    top: 36%;
    left: 73.3%;
  }
  .decentralization-tooltip {
    top: 47%;
    left: 79.5%;
  }
  /*@media (max-width: 1400px) {*/
    /*.mobile-tooltip {*/
      /*left: -1.2%;*/
    /*}*/
    /*.iot-tooltip {*/
      /*left: -4%;*/
    /*}*/
    /*.tracking-tooltip {*/
      /*left: -1.4%;*/
    /*}*/
    /*.any-format-tooltip {*/
      /*left: -4.8%;*/
    /*}*/
    /*.sensitize-tooltip {*/
      /*left: 26.9%;*/
    /*}*/
    /*.scheme-tooltip {*/
      /*top: 71.5%;*/
      /*left: 17.3%;*/
    /*}*/
    /*.data-lake-tooltip {*/
      /*left: 39%;*/
    /*}*/
    /*.enrich-tooltip {*/
      /*left: 38.8%;*/
    /*}*/
    /*.consumer-tooltip {*/
      /*left: 45.3%;*/
    /*}*/
    /*.api-tooltip {*/
      /*left: 58.5%;*/
    /*}*/
    /*.optimization-tooltip {*/
      /*left: 65%;*/
    /*}*/
    /*.marketing-tooltip {*/
      /*left: 58.2%;*/
    /*}*/
    /*.reporting-tooltip {*/
      /*top: 43.5%;*/
      /*left: 62%;*/
    /*}*/
    /*.campaign-tooltip {*/
      /*left: 71.2%;*/
    /*}*/
    /*.decentralization-tooltip {*/
      /*top: 47.5%;*/
      /*left: 77.5%;*/
    /*}*/
  /*}*/
  @media (max-width: 1199px) {
    .mobile-tooltip {
      top: 17.5%;
      left: -2.2%;
    }
    .iot-tooltip {
      top: 31.5%;
      left: -5%;
    }
    .tracking-tooltip {
      top: 45%;
      left: -3%;
    }
    .any-format-tooltip {
      top: 60%;
      left: -5%;
    }
    .sensitize-tooltip {
      top: 15.5%;
      left: 25%;
    }
    .scheme-tooltip {
      top: 68.5%;
      left: 15.5%;
    }
    .data-lake-tooltip {
      top: 61%;
      left: 37%;
    }
    .enrich-tooltip {
      top: 3.5%;
      left: 37%;
    }
    .consumer-tooltip {
      top: 62%;
      left: 43.3%;
    }
    .api-tooltip {
      left: 57%;
    }
    .optimization-tooltip {
      top: 29.5%;
      left: 63%;
    }
    .marketing-tooltip {
      top: 36%;
      left: 56%;
    }
    .reporting-tooltip {
      top: 40.5%;
      left: 60%;
    }
    .campaign-tooltip {
      top: 35%;
      left: 69.2%;
    }
    .decentralization-tooltip {
      top: 45.5%;
      left: 76%;
    }
  }
  @media (max-width: 991px) {
    .mobile-tooltip,
    .iot-tooltip,
    .tracking-tooltip,
    .any-format-tooltip,
    .scheme-tooltip {
      display: none;
    }
    .sensitize-tooltip {
      top: 24.5%;
      left: 60.5%;
    }
    .data-lake-tooltip {
      top: 36.5%;
      left: auto;
      right: -6%;
    }
    .consumer-tooltip {
      top: 39.5%;
      left: 50.5%;
    }
    .enrich-tooltip {
      top: 42%;
      left: -5%;
    }
    .api-tooltip {
      top: 58.5%;
      left: auto;
      right: -1.5%;
    }
    .optimization-tooltip {
      top: 63.5%;
      left: 41%;
    }
    .marketing-tooltip {
      top: 53.5%;
      left: 32%;
    }
    .reporting-tooltip {
      top: 57%;
      left: 19%;
    }
    .campaign-tooltip {
      top: 67.5%;
      left: 30%;
    }
    .decentralization-tooltip {
      top: 77.5%;
      left: 22.5%;
    }
  }
  @media (max-width: 575px) {
    .sensitize-tooltip {
      top: 22%;
      left: auto;
      right: 0;
    }
    .data-lake-tooltip {
      top: 33%;
      right: 0;
    }
    .consumer-tooltip {
      top: 36.5%;
      left: auto;
      right: 0;
    }
    .enrich-tooltip {
      top: 38%;
      left: 0;
    }
    .api-tooltip {
      top: 54.5%;
      right: 0;
    }
    .optimization-tooltip {
      top: 60%;
      left: 31%;
    }
    .marketing-tooltip {
      top: 50%;
      left: 22%;
    }
    .reporting-tooltip {
      top: 53%;
      left: 8%;
    }
    .campaign-tooltip {
      top: 63.5%;
      left: 19%;
    }
    .decentralization-tooltip {
      top: 74.5%;
      left: 13%;
    }
  }
  @media (max-width: 479px) {
    .features-tooltip {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Features/SchemeTooltip.vue